import { Component, OnInit, Input, HostBinding, AfterViewInit, ElementRef } from '@angular/core';
import { ProjectAlert } from 'projects/app-misc/src/app/modules/alert/data/alert';
import * as  moment from 'moment';
import { ProjectWindowComponent } from '../../../project/view/project-window/project-window.component';
import { MatDialog } from '@angular/material/dialog';
import * as jq from 'jquery';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
    selector: 'app-project-alert',
    templateUrl: './project-alert.component.html',
    styleUrls: ['./project-alert.component.scss']
})
export class ProjectAlertComponent implements OnInit, AfterViewInit {

    @Input()
    projectAlert: ProjectAlert;

    timeToShow: string;

    @HostBinding('class.date-late')
    late = false;

    @HostBinding('class.alert-ready')
    ready = false;

    @Input()
    showProject = true;

    statusMessage: string;

    @Input()
    alertsOP: OverlayPanel

    constructor(
        protected elementRef: ElementRef,
        protected dialog: MatDialog
    ) { }

    ngOnInit() {
        this.timeToShow = moment(this.projectAlert.createdTime).calendar();
        this.checkLate();

        if (this.projectAlert.message) {
            const str = this.projectAlert.message;
            this.statusMessage = str
                .replace(/<(\w+)([^<]*)>/gim, '<span class=\"$1\"$2>')
                .replace(/<\/(\w+)>/gim, '</span>');
        }
    }


    checkLate() {
        const today = new Date();

        if (this.projectAlert.createdTime) {
            this.projectAlert.createdTime.setHours(23, 0, 0, 0);
            if (this.projectAlert.createdTime < this.projectAlert.resolvedTime) {
                this.ready = true;
            }
            else if (this.projectAlert.createdTime.getTime() < today.setHours(0, 0, 0, 0)) {
                this.late = true;
            }
        }
    }

    ngAfterViewInit() {
        const el = this.elementRef.nativeElement as HTMLElement
        const nfEl = jq(el.getElementsByClassName('project'))

        // tslint:disable-next-line: deprecation
        nfEl.click(jQEvent => {
            if (this.showProject) {
                this.openProjectWindow(this.projectAlert.projectId)
            }
        })
    }

    openProjectWindow(projectId: number) {
        if (this.alertsOP) {
            this.alertsOP.hide();
        }

        const dialogRef = this.dialog.open(ProjectWindowComponent, {
            data: {
                projectNumber: projectId,
            },
            panelClass: 'project-window-dialog'
        });

        dialogRef.afterClosed().subscribe(result => {
        });
    }
}